import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import OpacityIcon from "@mui/icons-material/Opacity";

const Humidity1Widget = ({ widget, onValueUpdate }) => {
  const [humidity, setHumidity] = useState(0);
  const [isFlashing, setIsFlashing] = useState(false);

  useEffect(() => {
    if (widget?.items?.$w1) {
      setHumidity(Number(widget.items.$w1.value));
      setIsFlashing(true);
      setTimeout(() => setIsFlashing(false), 500);
    }
  }, [widget]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        height: "100%",
        width: "100%",
        padding: 2,
        backgroundColor: isFlashing ? "secondary.main" : "background.default",
        borderRadius: 2,
        transition: "background-color 0.5s ease",
      }}
    >
      <Typography sx={{ fontSize: "1rem", fontWeight: 500 }}>
        {humidity.toFixed(1)} %
      </Typography>
      <OpacityIcon
        sx={{
          fontSize: "1.2rem",
          color: "#64B5F6",
        }}
      />
    </Box>
  );
};

export default Humidity1Widget;
